import { render, staticRenderFns } from "./MyTemplatePreview.vue?vue&type=template&id=128ff880&scoped=true&"
import script from "./MyTemplatePreview.vue?vue&type=script&lang=js&"
export * from "./MyTemplatePreview.vue?vue&type=script&lang=js&"
import style0 from "./MyTemplatePreview.vue?vue&type=style&index=0&id=128ff880&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128ff880",
  null
  
)

export default component.exports